import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getMessaging } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyCw34tGnL4NN_syVIw-FoBTuTqepbHOO84",
  authDomain: "taskonnect-f12e7.firebaseapp.com",
  projectId: "taskonnect-f12e7",
  storageBucket: "taskonnect-f12e7.firebasestorage.app",
  messagingSenderId: "1003475481873",
  appId: "1:1003475481873:web:144202c6e0d98395f488b0",
  measurementId: "G-LCZLTCBZL1"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
export const messaging = getMessaging(app);
export default app;